// Shared formatting utilities

export function formatCurrency(amount) {
  try {
    if (amount == null || isNaN(Number(amount))) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return '$0.00';
  }
}

export function formatDate(value) {
  if (!value) return '—';

  // Firestore Timestamp with toDate()
  if (value && typeof value.toDate === 'function') {
    const d = value.toDate();
    return formatShortDate(d);
  }

  // Firestore Timestamp-like object { seconds, nanoseconds }
  if (value && typeof value.seconds === 'number') {
    const d = new Date(value.seconds * 1000);
    return formatShortDate(d);
  }

  // Firestore Admin Timestamp serialized as {_seconds, _nanoseconds}
  if (value && typeof value._seconds === 'number') {
    const d = new Date(value._seconds * 1000);
    return formatShortDate(d);
  }

  // Milliseconds since epoch
  if (typeof value === 'number') {
    const d = new Date(value);
    return !isNaN(d) ? formatShortDate(d) : '—';
  }

  // ISO string or Date
  if (typeof value === 'string' || value instanceof Date) {
    const d = new Date(value);
    if (!isNaN(d)) return formatShortDate(d);

    // Unparseable string (e.g., "26 October 2025 at 01:53:16 UTC+1")
    return value;
  }

  // Fallback: try to construct
  try {
    const d = new Date(value);
    return !isNaN(d) ? formatShortDate(d) : '—';
  } catch {
    return '—';
  }
}

function formatShortDate(date) {
  return date?.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}